import Image from "@/components/atoms/Image";
import Para from "@/components/atoms/text/Para";
import Label from "@/atoms/text/Label";
import VideoModalTrigger from "@/components/molecules/VideoModalTrigger";
import { ClockBadgeIcon } from "@/atoms/Icons";

export default function CardWithImg({
  image,
  content,
  hasPlayBtn,
  videoSrc,
  label,
  href,
  isBlog,
  readTime,
}) {
  return (
    <>
      <div className={`card fx fx--c ps-r ${isBlog ? "blog-card" : ""}`}>
        <div className="ps-r">
          <Image
            fileName={image.fileName}
            fileFormat="jpg"
            desktopWidth={image.desktopWidth}
            mobileWidth={image.mobileWidth}
            alt={image.altName}
            isBannerImg={false}
            has2XWebp={image.has2XWebp}
            className={`${isBlog ? "overflow-hidden" : ""}`}
          />
          {readTime && (
            <div className="read-time">
              <ClockBadgeIcon />{" "}
              <span className="text--xs tc-white">{readTime}</span>
            </div>
          )}
          {hasPlayBtn && (
            <VideoModalTrigger
              src={videoSrc}
              btnSizeDesk="60"
              btnSizeMob="60"
              isSwiperBtn
              hasYTShorts
            />
          )}
        </div>
        <div className="content-wrapper bc-white">
          {label && (
            <Label size="md" color="grey-dark" className="bold mb-1">
              {label}
            </Label>
          )}
          <Para
            desktopSize="lg"
            mobileSize="lg"
            className="bold text--mont"
            dangerouslySetInnerHTML={{ __html: content }}
          />
        </div>
        {isBlog && <a href={href} className="full"></a>}
      </div>
      <style jsx>{`
        .card {
          border-radius: 8px;
          overflow: hidden;
          width: 360px;
          height: 100%;
        }
        .card:hover {
          box-shadow: 0px 4px 22px 4px rgba(51, 57, 61, 0.14);
        }
        .content-wrapper {
          padding: 24px;
          flex-grow: 1;
        }
        .btn {
          bottom: 32px;
          right: 32px;
        }
        .read-time {
          padding: 0 6px 2px;
          border-radius: 4px;
          background: #33393d;
          position: absolute;
          left: 24px;
          bottom: 24px;
          backdrop-filter: blur(2px);
          opacity: 0.85;
        }
        @media (max-width: 1199px) {
          .card {
            width: 280px;
          }
          .btn {
            bottom: 24px;
            right: 24px;
          }
        }
      `}</style>
    </>
  );
}
